// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"61":"sidebar","341":"modals","354":"accordions","399":"sliders","522":"maps","548":"storelocator","753":"marquee","808":"carousels","899":"dropdowns","954":"buttons"}[chunkId] + ".min.js";
};